import { isEmpty } from '@/shared/util';

import { appendQuillListUiSpan } from './builder.util';

export function hasEmptyListItems(html: string): boolean {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const listItems = doc.querySelectorAll('li');

  return Array.from(listItems).some((li) => isEmpty(li.textContent));
}

export function cleanAndPreserveListStructure(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const lists = doc.querySelectorAll('ol, ul');

  if (isEmpty(Array.from(lists))) {
    return html;
  }

  lists.forEach((list) => {
    const isOrdered = list.tagName === 'OL';
    const listItems = Array.from(list.children).filter(
      (child): child is HTMLLIElement => child instanceof HTMLLIElement,
    );

    listItems.forEach((listItem) => {
      const existingDataList = listItem.dataset.list;

      if (isEmpty(listItem.textContent)) {
        listItem.remove();

        return;
      }

      const listType = existingDataList || (isOrdered ? 'ordered' : 'bullet');

      listItem.dataset.list = listType;

      const existingUiSpan = listItem.querySelector('span.ql-ui');

      if (!existingUiSpan) {
        appendQuillListUiSpan(listItem);
      }
    });

    if (isEmpty(Array.from(list.children))) {
      list.remove();
    }
  });

  const result = doc.body.innerHTML.trim();

  return isEmpty(result) ? '' : result;
}

export function cleanHtmlWithLists(html: string): string {
  if (hasEmptyListItems(html)) {
    return cleanAndPreserveListStructure(html);
  }

  return html;
}
